/** 스토어 정리를 위한 최대 아이템 수 */
export const MAX_STORE_ITEMS = 1500;

/** 그룹 순서 관리를 위한 최대 그룹 수 */
export const MAX_GROUP_HISTORY = 2;
